import React from "react";
import ReportTable from "../ReportTable";
import "./ExecutiveOverview.css";

const ExecutiveOverview = () => {
  const cardsData = [
    {
      title: "Vets — avg utilization",
      value: "76%",
      subtitle: "1,885 consultations (7d)",
    },
    {
      title: "Pets — active",
      value: "150",
      subtitle: "79% reactivation rate",
    },
    {
      title: "Appointments (7d)",
      value: "228",
      subtitle: "9.4% no-show/reschedule",
    },
    {
      title: "Billing — sales (period)",
      value: "₹83.7L",
      subtitle: "₹60.5L outstanding",
    },
    {
      title: "Stock — low stock items",
      value: "13",
      subtitle: "₹68.9L stock value",
    },
    {
      title: "Services — top by revenue",
      value: "Cryptorchid Neutering - M",
      subtitle: "1,218 medical services delivered",
      isLargeText: true,
    },
  ];

  const attentionIssues = [
    {
      domain: "Vets",
      issue: "Utilization vs Capacity — 0 booked slots across all vets",
      severity: "Data bug",
    },
    {
      domain: "Appointments",
      issue: "Facility Utilization, Patient Wait Time, Time-Slot Heatmap — no data",
      severity: "Data bug",
    },
    {
      domain: "Billing",
      issue: 'Payment Mode values malformed ("Clinic Pay," "New Biller")',
      severity: "Data bug",
    },
    {
      domain: "Stock",
      issue: "Gross Margin 0.00 across rows; one product at -2,746.7% margin",
      severity: "Data bug + real exception",
    },
    {
      domain: "Services",
      issue: "Non-Medical Services showing 0 despite real Pet Shop/Pharmacy revenue in Billing",
      severity: "Data bug",
    },
  ];

  return (
    <div className="executive-overview-container">
      {/* Page Title */}
      <h2 className="executive-overview-title">Executive overview</h2>

      {/* 6 KPI Cards Grid */}
      <div className="executive-overview-cards-grid">
        {cardsData.map((card, index) => (
          <div className="executive-overview-card" key={index}>
            <h4 className="executive-overview-card-title">{card.title}</h4>
            <div className="executive-overview-card-value-container">
              <h2
                className={`executive-overview-card-value ${card.isLargeText ? "text-large" : ""
                  }`}
              >
                {card.value}
              </h2>
            </div>
            <div className="executive-overview-card-subtitle">
              {card.subtitle}
            </div>
          </div>
        ))}
      </div>

      {/* Attention Needed Section */}
      <div className="executive-attention-header">Attention needed</div>

      <div className="mtMin10">
        <ReportTable
          datas={attentionIssues}
          columns={["domain", "issue", "severity"]}
          maxHeight="none"
        />
      </div>
    </div>
  );
};

export default ExecutiveOverview;
